export const timeOptionsTranslations = {
  en: {
    standardRentalPeriods: "Tour Types",
    tourTypes: {
      daily: {
        label: "Daily Tour",
        description: "Explore the beauty of the area with a full-day tour."
      },
      sunset: {
        label: "Sunset Tour",
        description: "Enjoy a breathtaking sunset on the water."
      },
      swimming: {
        label: "Swimming Tour",
        description: "Relax and swim in crystal-clear waters."
      },
      oneHour: {
        label: "One-Hour Tour",
        description: "Perfect for a quick getaway."
      },
      evening: {
        label: "Evening Tour (Sunset Dinner Cruise)",
        description: "Experience a sunset dinner cruise."
      }
    },
    rentalDurationOptions: "Rental Duration Options",
    shortest: "Shortest",
    shortestDuration: "1 hour",
    longest: "Longest",
    longestDuration: "1 day",
    contactNote: "Contact us for costs of different rental durations"
  },
  tr: {
    standardRentalPeriods: "Tur Türleri",
    tourTypes: {
      daily: {
        label: "Günlük Tur",
        description: "Bölgenin güzelliklerini tam günlük bir turla keşfedin."
      },
      sunset: {
        label: "Gün Batımı Turu",
        description: "Suda muhteşem bir gün batımının keyfini çıkarın."
      },
      swimming: {
        label: "Yüzme Turu",
        description: "Berrak sularda yüzerek rahatlayın."
      },
      oneHour: {
        label: "Bir Saatlik Tur",
        description: "Hızlı bir kaçamak için mükemmel."
      },
      evening: {
        label: "Akşam Turu (Gün Batımı Akşam Yemeği)",
        description: "Gün batımı akşam yemeği turunu deneyimleyin."
      }
    },
    rentalDurationOptions: "Kiralama Süresi Seçenekleri",
    shortest: "En Kısa",
    shortestDuration: "1 saat",
    longest: "En Uzun",
    longestDuration: "1 gün",
    contactNote: "Farklı kiralama sürelerinin maliyetleri için bizimle iletişime geçin"
  },
  de: {
    standardRentalPeriods: "Tourtypen",
    tourTypes: {
      daily: {
        label: "Tägliche Tour",
        description: "Erkunden Sie die Schönheit der Gegend mit einer Ganztagestour."
      },
      sunset: {
        label: "Sonnenuntergangstour",
        description: "Genießen Sie einen atemberaubenden Sonnenuntergang auf dem Wasser."
      },
      swimming: {
        label: "Schwimmtour",
        description: "Entspannen Sie sich und schwimmen Sie im kristallklaren Wasser."
      },
      oneHour: {
        label: "Einstündige Tour",
        description: "Perfekt für einen kurzen Ausflug."
      },
      evening: {
        label: "Abendtour (Sonnenuntergangs-Dinner-Kreuzfahrt)",
        description: "Erleben Sie eine Sonnenuntergangs-Dinner-Kreuzfahrt."
      }
    },
    rentalDurationOptions: "Mietdaueroptionen",
    shortest: "Kürzeste",
    shortestDuration: "1 Stunde",
    longest: "Längste",
    longestDuration: "1 Tag",
    contactNote: "Kontaktieren Sie uns für die Kosten verschiedener Mietdauern"
  },
  ru: {
    standardRentalPeriods: "Типы туров",
    tourTypes: {
      daily: {
        label: "Ежедневный тур",
        description: "Исследуйте красоту местности с помощью однодневного тура."
      },
      sunset: {
        label: "Тур на закат",
        description: "Насладитесь захватывающим закатом на воде."
      },
      swimming: {
        label: "Тур для плавания",
        description: "Расслабьтесь и поплавайте в кристально чистой воде."
      },
      oneHour: {
        label: "Часовой тур",
        description: "Идеально для быстрого отдыха."
      },
      evening: {
        label: "Вечерний тур (Закатный ужин-круиз)",
        description: "Испытайте круиз с ужином на закате."
      }
    },
    rentalDurationOptions: "Варианты длительности аренды",
    shortest: "Самая короткая",
    shortestDuration: "1 час",
    longest: "Самая длинная",
    longestDuration: "1 день",
    contactNote: "Свяжитесь с нами для уточнения стоимости разных сроков аренды"
  }
};